let activityListenersAdded = false;

export function startActivityWatcher() {
  const isLoggedIn = sessionStorage.getItem("login") === "true";
  if (!isLoggedIn) return;

  const idleMinutes = Number(sessionStorage.getItem("expiryTimeInMintue")) || 15;
  const idleMs = idleMinutes * 60 * 1000;

  const updateActivity = () => {
    const newExpiry = Date.now() + idleMs;
    sessionStorage.setItem("activityExpiryTime", new Date(newExpiry)); // store as timestamp

  };

  // Set initial activity expiry
  updateActivity();

  // Add listeners only once (avoid duplicates)
  if (!activityListenersAdded) {
    ["mousemove", "keydown", "click", "scroll", "touchstart"].forEach((event) => {
      window.addEventListener(event, updateActivity);
    });
    activityListenersAdded = true;
  }

  return updateActivity;
}
